export const DescriptionItem = ({ title, text }) => (
    <div className="rounded-xl border p-4">
      <div className="font-semibold mb-4 text-sm">{title}</div>
      <p className="text-muted-foreground whitespace-pre-line text-xs">{text}</p>
    </div>
);